<template>

    <div class="product-add">
      <!--form表单-->
      <el-form size="small" ref="form" :model="form" label-width="200px">
        <!--添加门店-->
        <div class="common-form">添加</div>
        <el-form-item label="姓名 " prop="user_name" :rules="[{required: true,message: ' '}]">
          <el-input v-model="form.user_name" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="身份证号 " prop="user_id_code" :rules="[{required: true,message: ' '}]">
          <el-input v-model="form.user_id_code" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="手机号 " prop="user_phone" :rules="[{required: true,message: ' '}]">
          <el-input v-model="form.user_phone" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="风控类型 " prop="risk_type" :rules="[{required: true,message: ' '}]">
          <el-input v-model="form.risk_type" class="max-w460"></el-input>
          <div class="tips">风控类型(1、信息查询,2、贷前策略)</div>
        </el-form-item>
  
        <!--提交-->
        <div class="common-button-wrapper">
          <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
        </div>
  
  
      </el-form>
  
  
    </div>
  
  </template>
  
  <script>
    import FengkongApi from '@/api/fengkong.js';
    export default {
      data() {
        return {
          loading: false,
          /*form表单数据*/
          form: {
            user_name: '',
            user_id_code: '',
            user_phone:'',
            risk_type:2
          },
  
  
        };
      },
      created() {},
  
      methods: {
        //提交表单
        onSubmit() {
          let self = this;
          let form = this.form;
          self.$refs.form.validate((valid) => {
            if (valid) {
              self.loading = true;
              FengkongApi.riskAdd(form, true)
                .then(data => {
                  self.loading = false;
                  self.$message({
                    message: '恭喜你，添加成功',
                    type: 'success'
                  });
                  self.$router.push('/fengkong/fengkong/index');
                })
                .catch(error => {
                  self.loading = false;
                });
            }
          });
  
        },
  
      }
  
    };
  </script>
  
  <style>
    .tips {
      color: #ccc;
    }
  </style>
  


// WEBPACK FOOTER //
// src/views/fengkong/operation/add.vue